/**
 * The platform's action-button styling, in one place.
 *
 * These are the exact classes the entity-catalog and the LLM config screens already use —
 * a charcoal pill for the committing action, a white pill for everything beside it. They were
 * copied literally into each template, so a new screen written against Tailwind's `btn-primary`
 * came out indigo and read as a different product. Import these instead.
 */
export const ACTION_BUTTON = {
  /** The one committing action on a surface: save, add, apply. */
  primary:
    'btn inline-flex items-center gap-2 rounded-full bg-[#303030] px-5 py-2.5 text-sm font-medium text-white hover:bg-black disabled:opacity-50 dark:bg-gray-900 dark:hover:bg-black',

  /** Everything alongside it: cancel, reset, export, navigate. */
  secondary:
    'btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5',

  /** Toolbar scale — range toggles, per-panel export, pagination. */
  smallPrimary:
    'btn inline-flex items-center gap-2 rounded-full bg-[#303030] px-4 py-1.5 text-xs font-medium text-white hover:bg-black disabled:opacity-50 dark:bg-gray-900 dark:hover:bg-black',

  smallSecondary:
    'btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-1.5 text-xs font-medium text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5',
} as const;
